import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Helmet from 'react-helmet';

import styled, { createGlobalStyle } from 'styled-components'
import { breaks, colors, pattern, transition } from '../styles'

import Header from './header'
import Footer from './footer'

const Layout = (props) => <StaticQuery
  query={graphql`
    query LayoutQuery {
      allMarkdownRemark(
        filter: {
            frontmatter: { type: { eq: "page-options" } }
        }
      ){
        edges{
          node{
            frontmatter {
              logo
              header_text
              footer_text
              contact {
                person
                address
                citystatezip
                phone
                email
              }
            }
          }
        }
      }
    }
  `}
  render={data => {

    const siteOptions = data.allMarkdownRemark.edges[0].node.frontmatter;

    return (
      <div className={`site ${props.className}`}>
        <Helmet
					title="LIVEGIVEmidsouth"
				/>
        <GlobalStyles />
        <Header text={siteOptions.header_text} logo={siteOptions.logo} />
        {props.children}
        <Footer text={siteOptions.footer_text} contact={siteOptions.contact} />
      </div>
    )
  }}
/>

const StyledLayout = styled(Layout)`
  min-height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${pattern()}

  &:after {
    content: '';
    display: block;
    height: 90vmin;
    width: 90vmin;
    background-image: url('/images/leaf.png');
    background-size: cover;
    z-index: 1;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  & > * {
    position: relative;
    z-index: 2;
  }
`

const GlobalStyles = createGlobalStyle`
  html,
  body {
    margin: 0;
    padding: 0;
    font-size: 16px;
    overflow-x: hidden;
  }

  a {
    transition: ${transition};
    text-decoration: none;
  }

  * {
    box-sizing: border-box;
  }

  .markdown {
    font-weight: 700;
    font-size: 1.25rem;

    p a, a {
      color: ${colors.orange};

      &:hover {
        color: ${colors.blue};
      }
    }

    blockquote {
      text-align: left;
      font-size: 1.5em;
      font-style: italic;

      &:before, 
      &:after {
        content: '"';
        margin: 0 .25em;
        font-size: 1.25em;
      }

      &:before, 
      &:after,
      * {
        display: inline;
      }
    }

    ul, li {
      text-align: left;
    }

    img {
      ${breaks.tablet(`
        width: 50%;
        margin: 0 auto;
    `)}
    }
  }
`

export default StyledLayout
